/**
 * Preisanfrage (B2B): Anfrageliste, Drawer und Versand.
 *
 * Ersetzt die App "SA Request a Quote" von Samita. Markup in
 * snippets/g24-anfrage-drawer.liquid (Drawer, Formular, Pill) und
 * snippets/g24-anfrage-button.liquid (Buttons auf Produktseite und Kachel).
 *
 * Die Liste liegt in localStorage, damit sie Seitenwechsel ueberlebt. Ist der
 * Speicher gesperrt (privater Modus, blockierte Website-Daten), lebt sie nur
 * bis zum naechsten Seitenaufruf im Speicher dieser Seite.
 *
 * Versand: natives Absenden an Shopifys Kontaktformular, kein fetch. Ein
 * fetch an /contact meldet Erfolg, auch wenn Shopify eine Captcha-Pruefung
 * verlangt, und die Anfrage kommt nie an. Ausserdem patchen Apps hier
 * window.fetch.
 */
(() => {
  const SCHLUESSEL = 'g24-anfrage';
  const FLAG = 'g24-anfrage-gesendet';
  const MAX_POSITIONEN = 50;
  const MAX_MENGE = 9999;

  const dialog = document.getElementById('g24-anfrage');
  if (!dialog || typeof dialog.show !== 'function') return;

  const form = document.getElementById('g24-anfrage-form');
  const listeEl = dialog.querySelector('[data-g24-anfrage-liste]');
  const leerEl = dialog.querySelector('[data-g24-anfrage-leer]');
  const hinweisEl = dialog.querySelector('[data-g24-anfrage-hinweis]');
  const feldArtikel = dialog.querySelector('[data-g24-anfrage-feld-artikel]');
  const ansichtListe = dialog.querySelector('[data-g24-anfrage-ansicht="liste"]');
  const ansichtDanke = dialog.querySelector('[data-g24-anfrage-ansicht="danke"]');
  const pill = document.querySelector('[data-g24-anfrage-open]');
  const overlay = document.querySelector('.g24-anfrage-overlay');
  let fokusVorher = null;
  const pillZahl = pill && pill.querySelector('[data-g24-anfrage-zahl]');

  /* ---------- Texte ---------- */

  // Je Sprache aus data-g24-anfrage-i18n (g24-anfrage-drawer.liquid). Die
  // deutschen Werte hier sind nur der Rueckfall, falls das Element fehlt.
  const TEXTE = {
    requestPrice: 'Preis anfragen',
    inRequest: '✓ In der Anfrage',
    sku: 'Art.-Nr.',
    quantity: 'Menge',
    quantityDecrease: 'Menge verringern',
    quantityIncrease: 'Menge erhöhen',
    remove: 'Entfernen'
  };
  try {
    const i18nEl = document.querySelector('[data-g24-anfrage-i18n]');
    if (i18nEl) {
      const geladen = JSON.parse(i18nEl.textContent);
      const dekodierer = document.createElement('textarea');
      Object.keys(TEXTE).forEach((k) => {
        if (typeof geladen[k] === 'string' && geladen[k]) {
          dekodierer.innerHTML = geladen[k];
          TEXTE[k] = dekodierer.value;
        }
      });
    }
  } catch (e) {
    /* Rueckfall auf die deutschen Texte */
  }

  /* ---------- Speicher ---------- */

  const lesenRoh = () => {
    try {
      const daten = JSON.parse(localStorage.getItem(SCHLUESSEL) || '[]');
      return Array.isArray(daten) ? daten.filter((p) => p && p.id) : [];
    } catch (e) {
      return [];
    }
  };

  let liste = lesenRoh();

  const speichern = () => {
    try {
      localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {
      /* gesperrter Speicher: Liste bleibt fuer diese Seite im Speicher */
    }
    aktualisieren();
  };

  const menge = (wert) => {
    const zahl = parseInt(wert, 10);
    if (!Number.isFinite(zahl) || zahl < 1) return 1;
    return Math.min(zahl, MAX_MENGE);
  };

  /* ---------- Tracking, ohne personenbezogene Daten ---------- */

  const tracken = (event, daten) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, g24_anfrage: daten });
  };

  /* ---------- Darstellung ---------- */

  const element = (tag, klasse, text) => {
    const el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (text != null) el.textContent = text;
    return el;
  };

  const zeileBauen = (pos) => {
    const li = element('li', 'g24-anfrage__pos');

    const bild = element('div', 'g24-anfrage__bild');
    if (pos.img) {
      const img = document.createElement('img');
      img.src = pos.img;
      img.alt = '';
      img.width = 64;
      img.height = 64;
      img.loading = 'lazy';
      bild.appendChild(img);
    }
    li.appendChild(bild);

    const info = element('div', 'g24-anfrage__info');
    const titel = element('a', 'g24-anfrage__name', pos.t);
    titel.href = pos.u || '#';
    info.appendChild(titel);
    const details = [pos.vt, pos.sku ? `${TEXTE.sku} ${pos.sku}` : ''].filter(Boolean).join(' · ');
    if (details) info.appendChild(element('p', 'g24-anfrage__details', details));

    const steuerung = element('div', 'g24-anfrage__steuerung');
    const minus = element('button', 'g24-anfrage__mengen-btn', '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', `${TEXTE.quantityDecrease}: ${pos.t}`);
    minus.dataset.aktion = 'minus';
    const feld = document.createElement('input');
    feld.type = 'number';
    feld.inputMode = 'numeric';
    feld.min = '1';
    feld.max = String(MAX_MENGE);
    feld.value = String(pos.q);
    feld.className = 'g24-anfrage__menge';
    feld.setAttribute('aria-label', `${TEXTE.quantity}: ${pos.t}`);
    feld.dataset.aktion = 'menge';
    const plus = element('button', 'g24-anfrage__mengen-btn', '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', `${TEXTE.quantityIncrease}: ${pos.t}`);
    plus.dataset.aktion = 'plus';
    const weg = element('button', 'g24-anfrage__entfernen', TEXTE.remove);
    weg.type = 'button';
    weg.setAttribute('aria-label', `${TEXTE.remove}: ${pos.t}`);
    weg.dataset.aktion = 'entfernen';
    steuerung.append(minus, feld, plus, weg);
    info.appendChild(steuerung);

    li.appendChild(info);
    li.dataset.id = pos.id;
    return li;
  };

  const kartenMarkieren = () => {
    const drin = new Set(liste.map((p) => String(p.id)));
    document.querySelectorAll('[data-g24-anfrage-add][data-kontext="karte"]').forEach((btn) => {
      const ist = drin.has(String(btn.dataset.variante));
      btn.classList.toggle('is-added', ist);
      const label = btn.querySelector('[data-g24-anfrage-label]');
      if (label) label.textContent = ist ? TEXTE.inRequest : TEXTE.requestPrice;
    });
  };

  const aktualisieren = () => {
    listeEl.replaceChildren(...liste.map(zeileBauen));
    const leer = liste.length === 0;
    leerEl.hidden = !leer;
    if (form) form.hidden = leer;
    dialog.querySelectorAll('[data-g24-anfrage-mit-artikeln]').forEach((el) => {
      el.hidden = leer;
    });
    if (!leer && hinweisEl) hinweisEl.hidden = true;

    if (pill) {
      pill.hidden = leer || dialog.open;
      if (pillZahl) pillZahl.textContent = String(liste.length);
    }
    kartenMarkieren();
  };

  /* ---------- Oeffnen und Schliessen ---------- */

  // Nicht-modal mit eigenem Overlay, siehe Kommentar im Snippet (hCaptcha).
  const oeffnen = (ansicht = 'liste') => {
    ansichtListe.hidden = ansicht !== 'liste';
    ansichtDanke.hidden = ansicht !== 'danke';
    if (!dialog.open) {
      fokusVorher = document.activeElement;
      dialog.show();
      if (overlay) overlay.hidden = false;
      const zu = dialog.querySelector('.g24-anfrage__zu');
      if (zu) zu.focus({ preventScroll: true });
    }
    if (pill) pill.hidden = true;
  };

  const schliessen = () => {
    if (dialog.open) dialog.close();
  };

  dialog.addEventListener('close', () => {
    if (overlay) overlay.hidden = true;
    ansichtListe.hidden = false;
    ansichtDanke.hidden = true;
    aktualisieren();
    if (fokusVorher && typeof fokusVorher.focus === 'function') fokusVorher.focus({ preventScroll: true });
    fokusVorher = null;
  });

  // Escape schliesst, das macht ein nicht-modaler Dialog nicht von selbst.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dialog.open) schliessen();
  });

  /* ---------- Hinzufuegen ---------- */

  const variantenDaten = (btn, variantenId) => {
    const skript = btn.parentElement && btn.parentElement.querySelector('[data-g24-anfrage-varianten]');
    if (!skript) return null;
    try {
      return JSON.parse(skript.textContent).find((v) => String(v.id) === String(variantenId)) || null;
    } catch (e) {
      return null;
    }
  };

  const hinzufuegen = (btn) => {
    const produktseite = btn.dataset.kontext === 'produkt';
    let variantenId = btn.dataset.variante;
    let anzahl = 1;
    let variantenTitel = btn.dataset.variantenTitel || '';
    let sku = btn.dataset.sku || '';

    // Auf der Produktseite zaehlen gewaehlte Variante und Menge aus dem
    // Produktformular. querySelector statt form.id: form.id liefert bei
    // Shopify das Varianten-Input und nicht das id-Attribut.
    const produktForm = produktseite ? btn.closest('form') : null;
    if (produktForm) {
      const idFeld = produktForm.querySelector('[name="id"]');
      if (idFeld && idFeld.value) variantenId = idFeld.value;
      const mengenFeld = produktForm.querySelector('[name="quantity"]');
      if (mengenFeld) anzahl = menge(mengenFeld.value);
      const v = variantenDaten(btn, variantenId);
      if (v) {
        variantenTitel = v.t || '';
        sku = v.sku || '';
      }
    }

    // Kachel: ist der Artikel schon drin, nur die Liste zeigen.
    const vorhanden = liste.find((p) => String(p.id) === String(variantenId));
    if (vorhanden && !produktseite) {
      oeffnen();
      return;
    }

    if (vorhanden) {
      vorhanden.q = menge(vorhanden.q + anzahl);
    } else {
      if (liste.length >= MAX_POSITIONEN) {
        oeffnen();
        return;
      }
      liste.push({
        id: String(variantenId),
        p: btn.dataset.produkt,
        t: btn.dataset.titel || '',
        vt: variantenTitel,
        sku,
        u: btn.dataset.url || '',
        img: btn.dataset.bild || '',
        q: anzahl,
      });
    }
    speichern();
    tracken('g24_anfrage_add', {
      item_id: String(variantenId),
      item_name: btn.dataset.titel || '',
      quantity: anzahl,
      kontext: btn.dataset.kontext,
    });
    oeffnen();
  };

  /* ---------- Klicks, delegiert fuer nachgeladene Kacheln ---------- */

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-g24-anfrage-add]');
    if (add) {
      // stopPropagation zusaetzlich: auf der Kachel liegt der Produktlink.
      e.preventDefault();
      e.stopPropagation();
      hinzufuegen(add);
      return;
    }
    if (e.target.closest('[data-g24-anfrage-open]')) {
      oeffnen();
      return;
    }
    if (e.target.closest('[data-g24-anfrage-zu]')) {
      schliessen();
    }
  });

  listeEl.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-aktion]');
    if (!btn) return;
    const li = btn.closest('li');
    const pos = li && liste.find((p) => p.id === li.dataset.id);
    if (!pos) return;
    if (btn.dataset.aktion === 'entfernen') {
      liste = liste.filter((p) => p !== pos);
    } else if (btn.dataset.aktion === 'plus') {
      pos.q = menge(pos.q + 1);
    } else if (btn.dataset.aktion === 'minus') {
      pos.q = menge(pos.q - 1);
    }
    speichern();
  });

  listeEl.addEventListener('change', (e) => {
    if (e.target.dataset.aktion !== 'menge') return;
    const li = e.target.closest('li');
    const pos = li && liste.find((p) => p.id === li.dataset.id);
    if (!pos) return;
    pos.q = menge(e.target.value);
    speichern();
  });

  /* ---------- Absenden ---------- */

  const artikelText = () =>
    liste
      .map((p, i) => {
        const teile = [`${i + 1}) ${p.q} x ${p.t}`];
        if (p.vt) teile.push(`Variante: ${p.vt}`);
        if (p.sku) teile.push(`Art.-Nr.: ${p.sku}`);
        if (p.u) teile.push(window.location.origin + p.u);
        return teile.join(' | ');
      })
      .join('\n');

  if (form) {
    form.addEventListener('submit', (e) => {
      const honeypot = form.querySelector('[name="contact[Website]"]');
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }
      if (!liste.length) {
        e.preventDefault();
        if (hinweisEl) hinweisEl.hidden = false;
        return;
      }
      feldArtikel.value = artikelText();
      try {
        sessionStorage.setItem(FLAG, '1');
      } catch (err) {
        /* ohne Flag gibt es nach dem Neuladen nur keine Danke-Ansicht */
      }
      tracken('g24_anfrage_submit', {
        positionen: liste.length,
        stueck: liste.reduce((summe, p) => summe + p.q, 0),
      });
    });
  }

  /* ---------- Rueckkehr nach dem Absenden ---------- */

  const nachDemAbsenden = () => {
    let flag = null;
    try {
      flag = sessionStorage.getItem(FLAG);
    } catch (e) {
      return;
    }
    if (!flag) return;

    const status = form && form.querySelector('[data-g24-anfrage-status]');
    const zurueck = /[?&]contact_posted=/.test(window.location.search);
    if (!status && !zurueck) return;

    try {
      sessionStorage.removeItem(FLAG);
    } catch (e) {
      /* egal */
    }

    if (status && status.dataset.g24AnfrageStatus === 'ok') {
      tracken('g24_anfrage_erfolg', { positionen: liste.length });
      liste = [];
      speichern();
      oeffnen('danke');
    } else {
      oeffnen();
    }
  };

  // Andere Tabs halten die Liste aktuell.
  window.addEventListener('storage', (e) => {
    if (e.key !== SCHLUESSEL) return;
    liste = lesenRoh();
    aktualisieren();
  });

  // Filter und Sortierung laden die Kacheln per AJAX neu.
  document.addEventListener('on:facet-filters:updated', kartenMarkieren);

  aktualisieren();
  nachDemAbsenden();
})();
